import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsLeftRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M26.9201 21.62C26.8701 21.5 26.8001 21.39 26.7001 21.29L22.7001 17.29C22.3101 16.9 21.6801 16.9 21.2901 17.29C20.9001 17.68 20.9001 18.31 21.2901 18.7L23.5801 20.99H6.00012C5.45012 20.99 5.00012 21.44 5.00012 21.99C5.00012 22.54 5.45012 22.99 6.00012 22.99H23.5901L21.3001 25.28C20.9101 25.67 20.9101 26.3 21.3001 26.69C21.5001 26.89 21.7501 26.98 22.0101 26.98C22.2701 26.98 22.5201 26.88 22.7201 26.69L26.7201 22.69C26.8101 22.6 26.8901 22.49 26.9401 22.36C27.0401 22.12 27.0401 21.84 26.9401 21.6L26.9201 21.62Z",
		fill: "#202227"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.08012 10.38C5.13012 10.5 5.20012 10.61 5.30012 10.71L9.30012 14.71C9.50012 14.91 9.75012 15 10.0101 15C10.2701 15 10.5201 14.9 10.7201 14.71C11.1101 14.32 11.1101 13.69 10.7201 13.3L8.43012 11.01H26.0001C26.5501 11.01 27.0001 10.56 27.0001 10.01C27.0001 9.46002 26.5501 9.01002 26.0001 9.01002H8.41012L10.7001 6.72002C11.0901 6.33002 11.0901 5.70002 10.7001 5.31002C10.3101 4.92002 9.68012 4.92002 9.29012 5.31002L5.29012 9.31002C5.20012 9.40002 5.12012 9.51002 5.07012 9.64002C4.97012 9.88002 4.97012 10.16 5.07012 10.4L5.08012 10.38Z",
		fill: "#202227"
	})]
});
export default SvgArrowsLeftRight;
